<template>
  <div>
    <div class="flex flex-col mx-auto lg:border-b border-gray-100 mt-3 lg:mt-0">
      <div
        class="flex items-center justify-between h-14 p-3 md:justify-between w-full md:w-auto"
      >
        <div
          :class="`flex w-full lg:w-auto items-center ${
            !user
              ? 'justify-center mt-10 lg:mt-0 lg:justify-between'
              : 'justify-between'
          }`"
        >
          <Logo />
          <button
            v-if="user"
            type="button"
            class="flex items-center align-middle justify-center ml-10 hover:opacity-70 focus:outline-none"
            @click="logout"
          ></button>
        </div>
      </div>
    </div>

    <Nuxt />

    <div
      class="flex flex-col md:flex-row p-3 bg-gray-50 text-right items-center md:items-start"
    >
      <p
        class="font-light text-center md:text-left text-gray-500 text-xs mb-2 md:mb-0"
      >
        {{ '© The Co-ownership Company B.V.' }}
        {{ $moment().format('YYYY') }}.
        {{ $t('COMPONENT_LAYOUT_FOOTER_RIGHTS') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutOfflineFooter',
}
</script>
